import { Select } from '@radix-ui/themes';
import { useState } from 'react';

type Option = {
  label: string;
  value: string;
};

interface SelectProps {
  options: Option[];
  onChange?: (values: string) => void;
  placeholder?: string;
  className?: string;
}

const SingleSelect = ({ options, onChange, placeholder = 'Select...', className }: SelectProps) => {
  const [selected, setSelected] = useState<string>();

  const handleSelect: Select.RootProps['onValueChange'] = (value) => {
    setSelected(value);
    onChange?.(value);
  };

  return (
    <Select.Root size="3" value={selected} onValueChange={handleSelect}>
      <Select.Trigger aria-label="Role" placeholder={placeholder} className={className}>
        {selected ? options.find((option) => option.value === selected)?.label : placeholder}
      </Select.Trigger>
      <Select.Content>
        {options.map((option) => (
          <Select.Item key={option.value} value={option.value}>
            {option.label}
          </Select.Item>
        ))}
      </Select.Content>
    </Select.Root>
  );
};

export default SingleSelect;
